import { ActionValue } from '@keepeek/commons';

var ActionDisplayType;
(function (ActionDisplayType) {
    ActionDisplayType["MENU"] = "menu";
    ActionDisplayType["BUTTON"] = "button";
    ActionDisplayType["ACTION_BUTTON"] = "action_button";
})(ActionDisplayType || (ActionDisplayType = {}));
var actionList = [
    {
        labelKey: "components.dataview.action.attachment.label",
        testId: "showAttachmentButton",
        icon: "fa-solid fa-paperclip",
        value: ActionValue.SHOW_ATTACHMENT,
        showForBasket: true,
        showForShare: false,
        showForOneElement: false,
        showForManyElement: false
    },
    {
        labelKey: "components.dataview.action.download.label",
        testId: "downloadSelectionButton",
        icon: "fa-solid fa-cloud-arrow-down",
        value: ActionValue.DOWNLOAD,
        showForBasket: true,
        showForShare: true,
        showForOneElement: true,
        showForManyElement: true
    },
    {
        labelKey: "components.dataview.action.remove-from-basket.label",
        testId: "removeFromBasketButton",
        icon: "fa-solid fa-xmark",
        value: ActionValue.REMOVE_FROM_BASKET,
        showForBasket: true,
        showForShare: false,
        showForOneElement: false,
        showForManyElement: false
    },
    {
        labelKey: "components.dataview.action.insert.label",
        testId: "insert",
        icon: "fa-solid fa-file-plus",
        value: ActionValue.INSERT,
        showForBasket: true,
        showForShare: false,
        showForOneElement: true,
        showForManyElement: true
    },
    {
        labelKey: "components.dataview.action.add-to-basket.label",
        testId: "addToBasketButton",
        icon: "fa-solid fa-basket-shopping-plus",
        value: ActionValue.ADD_TO_BASKET,
        showForBasket: false,
        showForShare: false,
        showForOneElement: false,
        showForManyElement: true
    },
];

export { ActionDisplayType, actionList };
//# sourceMappingURL=constants.js.map
